import React, { useState, useEffect } from "react";
import { Radio, X, Minus, ShoppingBag } from "lucide-react";
import authService from "../services/authService";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Janela flutuante da live - enquanto o afiliado está com a live ativa
 * (TikTok Shop, Instagram Shopping), ele pode navegar pelo resto do
 * ClickHub (carteira, catálogo, pedidos) sem perder de vista o que está
 * acontecendo na venda.
 *
 * Importante: não espelha o vídeo do app de terceiro (TikTok/Instagram
 * não permitem isso oficialmente) - mostra os dados reais que o
 * ClickHub controla: produto atual, vendas de hoje, cliques.
 */
const JanelaFlutuanteLive = () => {
  const [dados, setDados] = useState(null);
  const [minimizada, setMinimizada] = useState(false);
  const [fechada, setFechada] = useState(false);

  useEffect(() => {
    const usuario = authService.getUser();
    if (!usuario || usuario.role !== "afiliado") return;

    const carregar = async () => {
      try {
        const resp = await authService.fetchAuth(`${BACKEND_URL}/api/social/live/resumo-tempo-real/${usuario.id}`);
        if (resp.ok) {
          const data = await resp.json();
          setDados(data);
        }
      } catch (error) {
        // Silencioso - nao deve incomodar com erro se a live nao estiver ativa
      }
    };

    carregar();
    const intervalo = setInterval(carregar, 15000);
    return () => clearInterval(intervalo);
  }, []);

  if (!dados || !dados.live_ativa || fechada) return null;

  if (minimizada) {
    return (
      <button
        onClick={() => setMinimizada(false)}
        className="fixed bottom-4 right-4 z-50 bg-red-600 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg animate-pulse"
      >
        <Radio className="w-6 h-6" />
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 w-64 bg-gray-900 border border-red-600 rounded-xl shadow-2xl overflow-hidden">
      <div className="bg-red-600 px-3 py-2 flex items-center justify-between">
        <span className="text-white text-xs font-bold flex items-center gap-1">
          <Radio className="w-3 h-3" /> AO VIVO
        </span>
        <div className="flex gap-1">
          <button onClick={() => setMinimizada(true)} className="text-white/80 hover:text-white">
            <Minus className="w-4 h-4" />
          </button>
          <button onClick={() => setFechada(true)} className="text-white/80 hover:text-white">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="p-3">
        {dados.imagem_atual && (
          <img src={dados.imagem_atual} alt="Produto na live" className="w-full h-28 object-cover rounded-lg mb-2" />
        )}
        <p className="text-white text-sm font-medium mb-2 line-clamp-2">{dados.produto_atual}</p>

        <div className="flex items-center justify-between text-xs">
          <div className="flex items-center gap-1 text-emerald-400">
            <ShoppingBag className="w-3 h-3" />
            <span>{dados.total_vendas_hoje} venda(s) hoje</span>
          </div>
          <span className="text-gray-500">{dados.total_clicks_hoje} clique(s)</span>
        </div>

        {dados.plataformas_conectadas && dados.plataformas_conectadas.length > 0 && (
          <p className="text-[10px] text-gray-500 mt-2">
            Transmitindo: {dados.plataformas_conectadas.join(", ")}
          </p>
        )}
      </div>
    </div>
  );
};

export default JanelaFlutuanteLive;
